import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaTentativasRestantes = (): TabelaColuna => ({
  Chave: 'tentativasRestantes',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 80 }}>Tent. Restantes</div>
})
